
const Auth = () => (
    <div>This is Auth!</div>
)

export default Auth
